import imageCompression from "browser-image-compression";

const handleImageCompress = async (
  imageFile: any,
  maxSize?: number
  //   maxWidthOrHeight?: number
) => {
  const options = {
    maxSizeMB: maxSize || 1,
    maxWidthOrHeight: 1920,
    useWebWorker: true,
  };
  try {
    const compressedBlob = await imageCompression(imageFile, options);
    const compressedFile = new File([compressedBlob], imageFile.name, {
      type: compressedBlob.type,
      lastModified: Date.now(),
    });
    return compressedFile;
  } catch (error) {
    console.log(error);
  }
};

export { handleImageCompress };
